/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const instanceLevelMappingSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  integrationInstanceId: z.int(),
  itemLevel: z.int(),
  organizationId: z.string(),
  sourceLevel: z.int(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
